// extracted by mini-css-extract-plugin
export default {"modalBody":"Modal_Body_modalBody__2ANch"};